module.exports = __webpack_public_path__ + "img/ferry-selected.5ce6a206.svg";